import { render, staticRenderFns } from "./AuditLog.vue?vue&type=template&id=540fba14&lang=pug&"
import script from "./AuditLog.vue?vue&type=script&lang=ts&"
export * from "./AuditLog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports